import getDetailDataPlugin from "./plugins/getDetailDataPlugin"

export default {
  mixins: [
    getDetailDataPlugin,
  ]
}
